export enum AttachmentTypeEnum {
  RG_FRENTE = "RG_FRENTE",
  RG_VERSO = "RG_VERSO",
  CPF_FRENTE = "CPF_FRENTE",
  CPF_VERSO = "CPF_VERSO",
  CNPJ_FRENTE = "CNPJ_FRENTE",
  CNPJ_VERSO = "CNPJ_VERSO",
  CTPS_FRENTE = "CTPS_FRENTE",
  CTPS_VERSO = "CTPS_VERSO",
  PIS_FRENTE = "PIS_FRENTE",
  PIS_VERSO = "PIS_VERSO",
  NIS_FRENTE = "NIS_FRENTE",
  NIS_VERSO = "NIS_VERSO",
  TITULO_ELEITOR_FRENTE = "TITULO_ELEITOR_FRENTE",
  TITULO_ELEITOR_VERSO = "TITULO_ELEITOR_VERSO",
  CRLV_FRENTE = "CRLV_FRENTE",
  CRLV_VERSO = "CRLV_VERSO",
  CNH_FRENTE = "CNH_FRENTE",
  CNH_VERSO = "CNH_VERSO",
  PASSAPORTE_FRENTE = "PASSAPORTE_FRENTE",
  PASSAPORTE_VERSO = "PASSAPORTE_VERSO",
  CREA_FRENTE = "CREA_FRENTE",
  CREA_VERSO = "CREA_VERSO",
  OAB_FRENTE = "OAB_FRENTE",
  OAB_VERSO = "OAB_VERSO",
  CRM_FRENTE = "CRM_FRENTE",
  CRM_VERSO = "CRM_VERSO",
  COREN_FRENTE = "COREN_FRENTE",
  COREN_VERSO = "COREN_VERSO",
  CRC_FRENTE = "CRC_FRENTE",
  CRC_VERSO = "CRC_VERSO",
  CRP_FRENTE = "CRP_FRENTE",
  CRP_VERSO = "CRP_VERSO",
  CORE_FRENTE = "CORE_FRENTE",
  CORE_VERSO = "CORE_VERSO",
  CRN_FRENTE = "CRN_FRENTE",
  CRN_VERSO = "CRN_VERSO",
  CRF_FRENTE = "CRF_FRENTE",
  CRF_VERSO = "CRF_VERSO",
  CRB_FRENTE = "CRB_FRENTE",
  CRB_VERSO = "CRB_VERSO",
  FOTO = "FOTO",
  AUTORIZACAO_VIAGEM = "AUTORIZACAO_VIAGEM",
  AUTORIZACAO_HOSPEDAGEM = "AUTORIZACAO_HOSPEDAGEM",
  LAUDO_MEDICO = "LAUDO_MEDICO",
  TERMO_DE_INSTITUICAO_DE_ENSINO = "TERMO_DE_INSTITUICAO_DE_ENSINO",
  RNE_FRENTE = "RNE_FRENTE",
  RNE_VERSO = "RNE_VERSO",
  DECLARACAO_TUTELAR = "DECLARACAO_TUTELAR",
  CREDENCIAL = "CREDENCIAL",
  CERTIFICADO = "CERTIFICADO",
  ATESTADO_PCD = "ATESTADO_PCD",
  LAUDO_PCD = "LAUDO_PCD",
  TERMO_RESPONSABILIDADE = "TERMO_RESPONSABILIDADE",
  LOGO_EVENTO = "LOGO_EVENTO",
}

type AttachmentTypeLabels = {
  [key in AttachmentTypeEnum]: string;
};

export const attachmentTypeLabels: AttachmentTypeLabels = {
  RG_FRENTE: "RG Frente",
  RG_VERSO: "RG Verso",
  CPF_FRENTE: "CPF Frente",
  CPF_VERSO: "CPF Verso",
  CNPJ_FRENTE: "CNPJ Frente",
  CNPJ_VERSO: "CNPJ Verso",
  CTPS_FRENTE: "CTPS Frente",
  CTPS_VERSO: "CTPS Verso",
  PIS_FRENTE: "PIS Frente",
  PIS_VERSO: "PIS Verso",
  NIS_FRENTE: "NIS Frente",
  NIS_VERSO: "NIS Verso",
  TITULO_ELEITOR_FRENTE: "Título Eleitor Frente",
  TITULO_ELEITOR_VERSO: "Título Eleitor Verso",
  CRLV_FRENTE: "CRLV Frente",
  CRLV_VERSO: "CRLV Verso",
  CNH_FRENTE: "CNH Frente",
  CNH_VERSO: "CNH Verso",
  PASSAPORTE_FRENTE: "Passaporte Frente",
  PASSAPORTE_VERSO: "Passaporte Verso",
  CREA_FRENTE: "CREA Frente",
  CREA_VERSO: "CREA Verso",
  OAB_FRENTE: "OAB Frente",
  OAB_VERSO: "OAB Verso",
  CRM_FRENTE: "CRM Frente",
  CRM_VERSO: "CRM Verso",
  COREN_FRENTE: "COREN Frente",
  COREN_VERSO: "COREN Verso",
  CRC_FRENTE: "CRC Frente",
  CRC_VERSO: "CRC Verso",
  CRP_FRENTE: "CRP Frente",
  CRP_VERSO: "CRP Verso",
  CORE_FRENTE: "CORE Frente",
  CORE_VERSO: "CORE Verso",
  CRN_FRENTE: "CRN Frente",
  CRN_VERSO: "CRN Verso",
  CRF_FRENTE: "CRF Frente",
  CRF_VERSO: "CRF Verso",
  CRB_FRENTE: "CRB Frente",
  CRB_VERSO: "CRB Verso",
  FOTO: "Foto",
  AUTORIZACAO_VIAGEM: "Autorização de Viagem",
  AUTORIZACAO_HOSPEDAGEM: "Autorização de Hospedagem",
  LAUDO_MEDICO: "Laudo Médico",
  TERMO_DE_INSTITUICAO_DE_ENSINO: "Termo de Instituição de Ensino",
  RNE_FRENTE: "RNE Frente",
  RNE_VERSO: "RNE Verso",
  DECLARACAO_TUTELAR: "Declaração Tutelar",
  CREDENCIAL: "Credencial",
  CERTIFICADO: "Certificado",
  ATESTADO_PCD: "Atestado PCD",
  LAUDO_PCD: "Laudo PCD",
  TERMO_RESPONSABILIDADE: "Termo de responsabilidade",
  LOGO_EVENTO: "Logo do evento",
};
